import { I3dObjectBrief } from '_data/types/Object3d';
import { IEmbededSharing, IShareUser, ISharingLink } from '_data/types/share';
import { Path, StringDate, Uuid, URL, Hex } from './base';
import { EUserRole, IUser, IUserBase } from './user';

export enum EProjectKind {
  ArtecStudio = 1,
  Leo = 2,
  ArtecCloud = 3,
  Phobos = 4,
}

export enum EProjectSource {
  FrontendUpload = 1,
  FrontendNew = 2,
  FrontendDuplication = 3,
  Leo = 4,
  AS = 5,
  ASFusionsSharing = 6,
  SupportLink = 7,
  ASDuplication = 8,
}

export enum EStorageItemKind {
  Folder = 'Folder',
  Project = 'Project',
}

export enum EProjectStatus {
  Preparing = 0,
  New = 1,
  Uploading = 2,
  Uploaded = 3,
  Processing = 4,
  Processed = 5,
  EnqueuedToDestroy = 6,
  Finalizing = 7,
  FailedToUpload = 8,
  FailedToConvert = 9,
}

export interface IAdditionalProjectInfo {
  project_type: EProjectKind;
  project_source: EProjectSource;
  hd: boolean;
  ws_version: boolean;
  objects_info: Record<Uuid, I3dObjectBrief>;
}

interface IActualWsVersion {
  id: number;
  meta: Record<string, unknown>;
  info: {
    objects_info: Record<Uuid, I3dObjectBrief>;
  };
}

interface IStorageItemBase {
  id: number;
  name: string;
  slug: string;
  user: IUserBase & {
    company?: IUser['company'];
    back_color?: Hex;
  };
  created_at: StringDate;
  uploaded_at?: StringDate;
  updated_at: StringDate;
  deleted: boolean;
  shared_with: IShareUser[];
  user_role: EUserRole;
  folder_id: number;
  type: EStorageItemKind; // TODO: split types from `folder` and `project`
  // TODO: make separate interface because `setRenamed` and 'isOwn' is custom UI field that was added to object entity
  setRenamed: boolean;
  isOwn: boolean;
}

export interface IProject extends IStorageItemBase {
  preview_presigned_url?: URL;
  status: EProjectStatus;
  for_support: boolean;
  additional_info: IAdditionalProjectInfo;
  last_edited_at?: StringDate;
  project_base: string;
  assets_path: Path;
  conversion_started_at: StringDate;
  support_deleting_started_at?: StringDate;
  licence_expired_at?: StringDate;
  actual_ws_version?: IActualWsVersion;
  project_type: EProjectKind;
  isOwn: boolean;
  sharing_links: ISharingLink[];
  embedded_sharings: IEmbededSharing[];
  description_preview?: string;
  demo: boolean;
  size?: number;
}

export interface IFolder extends IStorageItemBase {
  size: number;
  deny_rename: boolean;
  projects_count?: number;
}

export enum EStorageItemsSortField {
  Name = 'name',
  Size = 'size',
  UpdatedAt = 'updated_at',
  CreatedAt = 'created_at',
}

export enum EStorageItemsSortDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

export enum StorageItemsFilterValue {
  Deleted = 'deleted',
  All = 'all',
  My = 'my',
  SharedWithMe = 'shared_with_me',
}

export type IStorageItem = IProject | IFolder;
